var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NormalHeaderLayout',{attrs:{"header":"Latest security news"}},[_c('RSSList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }